<template>
  <v-container grid-list-xl>
    <div class="vue-contentido">
            <v-card>
                 <v-card-title class="grey lighten-4 change-font" primary-title>Detalle auditoría registro</v-card-title>
                <v-card-text>
                    <auditoriasoportes
                        :idtabla="this.tabla"
                        :idregistro="this.registro"
                    ></auditoriasoportes>
                </v-card-text>
            </v-card>
        </div>
  </v-container>
</template>

<script>
    import auditoriasoportes from "../../components/content/auditoriasoportes";
    export default {
        name: "detalleauditoria",
        data() {
            return {
                tabla: 0,
                registro: 0
            }
        },
        components: {
            auditoriasoportes
        },
        created(){
            this.tabla = parseInt(this.$route.params.idtabla);
            this.registro = parseInt(this.$route.params.idregistro);
        }
    }
</script>